__webpack_require__.p = "/reports-charts-repaint/onboarding/";